// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Motion$LiteracyplanetTupperware from "./Motion.res.mjs";
import * as NextArrow$LiteracyplanetTupperware from "../v2/NextArrow.res.mjs";
import * as V2ExerciseContext$LiteracyplanetTupperware from "../v2/V2ExerciseContext.res.mjs";
import * as MarkButtonStatesHook$LiteracyplanetTupperware from "../v2/MarkButtonStatesHook.res.mjs";

function PilotSimpleNav$ButtonAnimation(props) {
  return React.createElement(Motion$LiteracyplanetTupperware.Button.make, {
              whileTap: {
                scale: 0.9
              },
              whileHover: {
                scale: 1.2
              },
              className: props.className,
              onClick: Caml_option.some(props.onClick),
              children: props.children
            });
}

var ButtonAnimation = {
  make: PilotSimpleNav$ButtonAnimation
};

function PilotSimpleNav$BehaviourMarkButton(props) {
  var markState = props.markState;
  if (typeof markState !== "object") {
    switch (markState) {
      case "QuestionNotAttempted" :
      case "QuestionMarked" :
      case "AssessmentMode" :
          return null;
      
    }
  } else {
    var cb = markState._0;
    return React.createElement(PilotSimpleNav$ButtonAnimation, {
                onClick: (function (param) {
                    Curry._1(cb, undefined);
                  }),
                className: "p-2",
                children: "Am I Right?"
              });
  }
}

var BehaviourMarkButton = {
  make: PilotSimpleNav$BehaviourMarkButton
};

function PilotSimpleNav$BehaviourNextButton(props) {
  var match = V2ExerciseContext$LiteracyplanetTupperware.use();
  if (match.isEndscreenShowing || props.markState !== "QuestionMarked") {
    return null;
  }
  var onNextQuestion = match.onNextQuestion;
  return React.createElement(PilotSimpleNav$ButtonAnimation, {
              onClick: (function (param) {
                  Curry._1(onNextQuestion, undefined);
                }),
              className: "pilot-nav-button group pilot-nav-button-common",
              children: null
            }, React.createElement("div", undefined, "Next"), React.createElement(NextArrow$LiteracyplanetTupperware.make, {
                  className: "pilot-nav-button h-4 ml-4"
                }));
}

var BehaviourNextButton = {
  make: PilotSimpleNav$BehaviourNextButton
};

function PilotSimpleNav$BehaviourShowCorrectAnswerButton(props) {
  var match = V2ExerciseContext$LiteracyplanetTupperware.use();
  var onToggleShowCorrectAnswer = match.onToggleShowCorrectAnswer;
  var currentQuestionIndex = match.currentQuestionIndex;
  var answerVisible = Curry._1(match.isCorrectAnswerVisible, currentQuestionIndex);
  var marked = Curry._1(match.getMarkState, currentQuestionIndex);
  if (answerVisible !== undefined) {
    if (answerVisible) {
      return React.createElement(PilotSimpleNav$ButtonAnimation, {
                  onClick: (function (param) {
                      Curry._1(onToggleShowCorrectAnswer, undefined);
                    }),
                  className: "p-2",
                  children: "Show My Answer"
                });
    } else if (typeof marked !== "object" || marked._0.questionCorrect) {
      return null;
    } else {
      return React.createElement(PilotSimpleNav$ButtonAnimation, {
                  onClick: (function (param) {
                      Curry._1(onToggleShowCorrectAnswer, undefined);
                    }),
                  className: "p-2",
                  children: "Show Correct Answer"
                });
    }
  } else {
    return null;
  }
}

var BehaviourShowCorrectAnswerButton = {
  make: PilotSimpleNav$BehaviourShowCorrectAnswerButton
};

function PilotSimpleNav(props) {
  var markState = MarkButtonStatesHook$LiteracyplanetTupperware.use();
  return React.createElement(Motion$LiteracyplanetTupperware.Div.make, {
              animate: {
                transform: markState === "QuestionNotAttempted" ? "translateX(100%)" : "translateX(0px)"
              },
              transition: {
                type: "spring",
                duration: 1
              },
              className: "absolute bottom-0 right-0 rounded-tl-lg bg-indigo-800 flex text-white",
              children: Caml_option.some(null)
            }, React.createElement(PilotSimpleNav$BehaviourShowCorrectAnswerButton, {}), React.createElement(PilotSimpleNav$BehaviourMarkButton, {
                  markState: markState
                }), React.createElement(PilotSimpleNav$BehaviourNextButton, {
                  markState: markState
                }));
}

var make = PilotSimpleNav;

export {
  ButtonAnimation ,
  BehaviourMarkButton ,
  BehaviourNextButton ,
  BehaviourShowCorrectAnswerButton ,
  make ,
}
/* react Not a pure module */
